module.exports = __webpack_public_path__ + "static/assets/7be66868fd6747e965f68870a5e0dff7.svg";